import dayjs from "dayjs";

export function processFactura(factura, hasta) {
    let totalPagado = 0;
    let totalNotas = 0;

    factura.pagos = (factura.pagos ?? []).filter(pago => {
        if (dayjs(pago.fecha) <= hasta) {
            totalPagado += pago.monto;
            return true;
        }
        return false;
    });

    factura.notasCredito?.forEach(nota => {
        if (dayjs(nota.fecha) <= hasta) {
            totalNotas += nota.total;
        }
    });

    factura.totalNotasCredito = totalNotas;
    factura.total = factura.total - totalNotas;

    if (!['procesando', 'cancelada'].includes(factura.estado)) {
        factura.estado = totalPagado >= factura.total ? 'pagada' : 'pendiente';

        if (dayjs(factura.fecha_pago) > hasta && factura.tipo_pago === 'cheque') {
            factura.estado = 'procesando';
        }

        factura.por_cobrar = factura.total - totalPagado;
    }

    const plazo = factura.plazo?.nombre;
    const dias = factura.plazo?.dias;

    if (plazo?.toLowerCase().indexOf('contra') > -1) {
        factura.termino = 'CONTRA ENTREGA';
    } else if (dias > 0) {
        factura.termino = 'CRÉDITO';
    } else {
        factura.termino = 'CONTADO';
    }

    return factura;
}

export function buildRecibosParams(queryParams) {
    return {
        tipo_pago: queryParams.get("metodo_pago") ?? "",
        vendedor: queryParams.get("vendedor") ?? "",
        zona: queryParams.get("zona") ?? "",
        categoria: queryParams.get("categoria") ?? "",
        desde: queryParams.get("desde") ?? "",
        hasta: queryParams.get("hasta") ?? "",
        numeracion: queryParams.get("numeracion") ?? "",
        tipo_recibo: 'ingreso',
        paginate: 1000000,
    };
}

export function buildNotasVentasParams(queryParams) {
    return {
        vendedor: queryParams.get("vendedor") ?? "",
        desde: queryParams.get("desde") ?? "",
        hasta: queryParams.get("hasta") ?? "",
        categoria: queryParams.get("categoria") ?? "",
        numeracion: queryParams.get("numeracion") ?? "",
        tipo: 'venta',
        paginate: 1000000,
    };
}

// Returns { efectivo, transferencia, cheque, tarjeta, 'tarjeta-debito', deposito, otro, pagada,
//           contado, contraEntrega, credito }
export function calculateVentasSummaries(facturas, recibos) {
    const recibosIndex = new Set();
    const metodosPago = { efectivo: 0, transferencia: 0, cheque: 0, tarjeta: 0, 'tarjeta-debito': 0, deposito: 0, otro: 0, pagada: 0 };
    const terminos = { contado: 0, contraEntrega: 0, credito: 0, facturado: 0 };

    const addMetodoPago = (metodo, value) => {
        if (Object.prototype.hasOwnProperty.call(metodosPago, metodo))
            metodosPago[metodo] += value;
        else
            metodosPago.otro += value;
    };

    for (const recibo of recibos) {
        recibo.cuentas.forEach(cuenta => recibosIndex.add(cuenta.factura_id));
        if (recibo.status === "cancelado") continue;
        addMetodoPago(recibo.tipo_pago, recibo.abono_total);
    }

    for (const factura of facturas) {
        if (factura.estado === 'pagada' && !recibosIndex.has(factura.id)) {
            addMetodoPago(factura.tipo_pago, factura.total);
            metodosPago.pagada += factura.tipo_pago ? factura.total : 0;
        }
        if (factura.estado !== 'cancelada') {
            terminos.facturado += factura.total;
            if (factura.termino === 'CONTRA ENTREGA') {
                terminos.contraEntrega += factura.total;
            } else if (factura.termino === 'CRÉDITO') {
                terminos.credito += factura.total;
            } else {
                terminos.contado += factura.total;
            }
        }
        if (factura.estado === 'procesando') {
            addMetodoPago(factura.tipo_pago, factura.total);
        }
    }

    return { ...metodosPago, ...terminos };
}
